// Compile our scss
// This 'includes' the SCSS index file which webpack then reads and 
// compiles into the necessary css files
require('../scss/index.scss');

require('./global.js');
require('./photo-lightbox.js');
require('./secondary-nav.js');
require('./search-forms.js');
require('./accordion.js');
require('./random-image-gallery.js');
require('./responsive-images.js');
require('./fade-slider.js');
require('./button-cms-red.js');